<template>
  <div>
    <div v-if="youtube" class="youtube-holder">
      <iframe class="video-frame" :src="'https://www.youtube.com/embed/' + code" frameborder="0" 
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div v-if="!youtube" class="youtube-holder vimeo">
      <iframe ref="playerframe" 
        :src="'https://player.vimeo.com/video/' + code + '?autoplay=0&loop=1&autopause=1'" 
        width="100%" :height="viewHeight" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import VideoParser from '@/utils/video-parser.js'

export default {
  props: {
    url: String
  },
  computed: {
    code: function() {
      if(this.url) {
        if(this.youtube) {
          return VideoParser.getYoutubeCode(this.url)
        }
        return VideoParser.getVimeoCode(this.url)
      }
      return ''
    },
    youtube: function () {
      if(this.url) {
        return VideoParser.isYouTube(this.url)
      }
      return true
    }
  }
  
}
</script>

<style scoped>
.youtube-holder{
  position:relative;
}

.youtube-holder iframe{
  box-sizing:border-box;
  width:100%;
}
</style>
